// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"345":"13678e1a","649":"ca793640","870":"6e414400"}[chunkId] + ".chunk.js");